export default {"src":"/_next/static/media/donio-logo.9550aa06.svg","height":175,"width":420,"blurWidth":0,"blurHeight":0};